import { Card } from '@tribeplatform/react-ui-kit/Card'

import { BC } from '../../types/index.js'

export const CardContentBlock: BC<Record<string, never>> = Card.Content as BC<
  Record<string, never>
>
